export const heroReviews = (images, backgroundColor) => {
  const blackReviewLogos = images
    .filter(ele =>
      ['2OvSHiJkjSVL1VB48kbmli', '1BCz8kg8isBnEazo3RyezT', 'CsmFL9cUG5lF6g9wJK9vJ'].includes(
        ele.node.contentful_id
      )
    )
    .map(ele => ele.node);

  const whiteReviewLogos = images
    .filter(ele =>
      ['7Dg7v6YoqGBSDhLf8wEdaL', '4Hv9OEOfQi7cgyPqVdGkzE', '7n9xWOg3bq62jNFOGlwOUz'].includes(
        ele.node.contentful_id
      )
    )
    .map(ele => ele.node);

  return {
    stars: 4.5,
    title: '679 Reviews',
    starColor: '#FFCA43',
    starOffColor: '#E4E4E4',
    companyLogos: backgroundColor === 'White' ? blackReviewLogos : whiteReviewLogos,
  };
};
